export var AssetRenditionModels;
(function (AssetRenditionModels) {
    class AssetRendition {
        constructor(data) {
            Object.assign(this, data);
        }
    }
    AssetRenditionModels.AssetRendition = AssetRendition;
})(AssetRenditionModels || (AssetRenditionModels = {}));
//# sourceMappingURL=asset-rendition.models.js.map